import { useTranslate } from 'react-polyglot';

import {
  Description,
  StyledStatisticsIcon,
  Title,
  Wrapper,
} from './AnalyticsEmptyState.styled';

export const AnalyticsEmptyState = () => {
  const t = useTranslate();

  return (
    <Wrapper>
      <StyledStatisticsIcon />
      <Title>{t('__new.play.analyticsResults.empty.title')}</Title>
      <Description>{t('__new.play.analyticsResults.empty.description')}</Description>
    </Wrapper>
  );
};
